import { reactive } from "vue";
import { getProjectLifeCycle } from "@/request/view/project";

// 研发项目
export const rndProject = reactive([]);

// 研发项目下拉转换字段
export const rndFiledNames = { label: 'project', value: 'project', children: 'children' };

// 初始化项目数据
export const initRnDProject = () => {
    getProjectLifeCycle().then((res) => {
        rndProject.length = 0;
        if (res.code === 200 && res.message === '成功') {
            const projectList = res.data.filter((f) => f.project === '半自动天鹅')
            projectList.forEach((item) => {
                item.label = item.project;
                item.value = item.project;
            })
            rndProject.push(...projectList);
        }
    })
};

// 问题清单审核权限
export const closedLoopExamineAhtuority = (project, user) => {
    const [fProject] = rndProject.filter((f) => f.project === project);

    if (!fProject) {
        return false
    }
    return fProject.username === user;
};

// 工序选项
export const processesOption = [
    {
        label: "三大件",
        value: "三大件",
    },
    {
        label: "参考臂",
        value: "参考臂",
    },
    {
        label: "探测器",
        value: "探测器",
    },
    {
        label: "完整参考臂",
        value: "完整参考臂",
    },
    {
        label: "定标",
        value: "定标",
    },
    {
        label: "总装调试",
        value: "总装调试",
    },
    {
        label: "成品",
        value: "成品",
    },
    {
        label: "打包",
        value: "打包",
    },
];

// 问题闭环状态
export const closedLoopStatusOptions = [
    {
        label: "未开始",
        value: "未开始",
    },
    {
        label: "进行中",
        value: "进行中",
    },
    {
        label: "已完成",
        value: "已完成",
    },
];

// 审核状态
export const examineStatus = [
    {
        label: "不适用",
        value: "不适用",
    },
    {
        label: "待审核",
        value: "待审核",
    },
    {
        label: "通过",
        value: "通过",
    },
    {
        label: "不通过",
        value: "不通过",
    },
];

export const checkExamineStatus = (closedLoopStatus, examineStatus) => {
    if (closedLoopStatus === '未开始' || closedLoopStatus === '进行中') {
        return '不适用';
    }
    return examineStatus;
};
